export default __webpack_public_path__ + "static/media/nav_detail_image_2.1eb292ea.png";